<section>
    <h1 class="px-4 py-3 border-bottom" *ngIf="dialogHeader" mat-dialog-title>{{dialogHeader}} 
        <span class="material-icons-outlined fixed-pos" (click)="onNoClick()">
            close
            </span>
    </h1>
    <div mat-dialog-content>
        <p class="with-newlines">{{message}} 
            <span *ngFor="let roleNames of roleInfo; let i = index"><span *ngIf="i > 0">, </span> {{roleNames.roleName}}</span>
            <span> ?</span>
        </p>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end border-top">
        <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-2" cdkFocusInitial
            (click)="onYesClick()">Yes</button>
        <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button mr-2"
            (click)="onNoClick()">No</button>
    </div>
</section>
<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
</div>